<template>
  <div>
    <Search />
    <div style="height: 112px; width: 100%" />
    <div class="p-content box-container">
      <div class="box-title">会员体系</div>
      <div class="box-item">一、注册会员</div>
      <div class="box-content">在浪潮终端优选注册的用户，统称注册会员。</div>
      <div class="box-item">二、普通会员</div>
      <div class="box-content">完成注册账号信息填写，即可成为普通会员。</div>
      <div class="box-item">三、企业会员</div>
      <div class="box-content">
        完成注册账号信息填写的基础上，补充完善企业信息，经审核后，将成为企业会员。
      </div>
      <div class="box-content">
        普通会员进入浪潮终端优选首页，点击右上角的“会员中心”。
      </div>
      <img src="@/assets/imgs/noob/member-1-nologo.png">
      <div class="box-content">
        进入“会员信息”界面，可以查看会员等级，点击“升级为企业用户”。
      </div>
      <img src="@/assets/imgs/noob/member-2.png">
      <div class="box-content">
        填写企业的相关信息，上传资质及授权书，经审核后可称为企业会员。
      </div>
      <img src="@/assets/imgs/noob/member-3.png">
      <div class="box-item">四、企业会员级别</div>
      <table class="box-table">
        <tr>
          <td colspan="2">普通用户</td>
        </tr>
        <tr>
          <td colspan="2">企业用户</td>
        </tr>
        <tr>
          <td rowspan="4">代理商</td>
          <td>银牌增值</td>
        </tr>
        <tr>
          <td>金牌增值</td>
        </tr>
        <tr>
          <td>经销商</td>
        </tr>
        <tr>
          <td>行业方案</td>
        </tr>
        <tr>
          <td rowspan="2">分销商</td>
          <td>银牌分销</td>
        </tr>
        <tr>
          <td>钻石分销</td>
        </tr>
      </table>
      <div class="box-item">五、企业权益</div>
      <div class="box-content">
        商品特惠、尊享特权、专享商品、专享折扣、价格超低！
      </div>
      <div class="box-item">六、企业评级周期</div>
      <div class="box-content">自然年。</div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'MemberSystem',
  components: {
    Search
  },
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0)
    next()
  }
}
</script>

<style scoped>
.box-container {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 50px;
}
.box-title {
  font-size: 18px;
  color: black;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
}
.box-item {
  font-size: 16px;
  color: #3f3f3f;
  font-weight: bold;
  margin-top: 15px;
  line-height: 25px;
}
.box-content {
  font-size: 14px;
  color: #3f3f3f;
  margin-top: 10px;
  text-indent: 2em;
  line-height: 25px;
}
.box-container img {
  width: 60%;
  margin-top: 5px;
}
.box-table {
  color: #3f3f3f;
  font-size: 14px;
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: 5px;
}
.box-table td {
  width: 100px;
  height: 30px;
  text-align: center;
  border: 1px solid #ccc;
}
</style>
